<template>
   <div class="crud-wrapper">
      <crud :filterBy="{filters: dataFilter, isAffiliate: true, isMaster: isMaster()}" :grid-columns="gridColumns"
        alwaysUpdate="typeId,bankId,amount,term,netAmount" :gridSettings="{noNew: true, noRefresh: true, noSearch: false, noExport: true, noChooser: true, noGroup: false, multiSelectable: false}"
            :grid-options="gridOptions" :key="reRender" obj="contract" ref="crud">
      </crud>
   </div>
</template>

<script>
    import numeral from 'numeral';
    import PageClass from '@consigmais-team/vue-common/layout/defaultPage/pageClass';
    import ContractForm from './ContractForm';

    export default PageClass.extend({
        name: 'Contracts',

        props: ['kind'],

        watch: {
            async kind (newValue) {
                await this.init();
                this.reRender = +new Date();
            }
        },

        data () {
            return {
                ContractForm,
                reRender: 0,
                gridColumns: null,
                gridOptions: {
                    summary: {
                       texts: { sum: '' },
                       totalItems: [
                          {
                             column: 'netAmount',
                             valueFormat: {
                                type: 'fixedPoint',
                                precision: 2
                             },
                             summaryType: 'sum'
                          }
                       ],
                       groupItems: [
                          {
                             column: 'id',
                             summaryType: 'count',
                             displayFormat: "{0}",
                          },
                          {
                             column: 'netAmount',
                             valueFormat: {
                                type: 'fixedPoint',
                                precision: 2
                             },
                             summaryType: 'sum',
                             displayFormat: " Total: {0}",
                          }
                       ]
                    },
                },
                dataFilter: {}
            };
        },

        created () {
            this.init();
        },

        methods: {
            isMaster () {
                return this.$uCan({ key: 'subAfiliados' }) === 1;
            },
            
            pageFiltersChange (filters) {
                this.dataFilter = {
                    // storeId: filters.storeId ? filters.storeId : null,
                    statusId: filters.statusId ? filters.statusId : null,
                    clientId: filters.clientId ? filters.clientId : null,
                    typeId: filters.typeId ? filters.typeId : null,
                    covenantId: filters.covenantId ? filters.covenantId : null,
                    bankId: filters.bankId ? filters.bankId : null,
                    beginDate: filters.dateRange && filters.dateRange[0] ? filters.dateRange[0] : null,
                    endDate: filters.dateRange && filters.dateRange[1] ? filters.dateRange[1] : null,
                    affiliateId: filters.affiliateId ? filters.affiliateId : null,
                    campaignLinkId: filters.campaignLinkId ? filters.campaignLinkId : null
                };
            },

            async init () {
                this.gridColumns = [
                    {
                        dataField: 'storeName',
                        caption: 'Empresa',
                        minWidth: 150,
                        groupIndex: 0
                    },
                    {
                        dataField: 'statusName',
                        caption: 'Situação',
                        width: 120,
                        groupIndex: 2
                    },
                    {
                        dataField: 'covenantName',
                        caption: 'Convênio',
                        minWidth: 100
                    },
                    {
                        dataField: 'name',
                        caption: 'Cliente',
                        minWidth: 150
                    },
                    {
                        dataField: 'bankName',
                        caption: 'Banco',
                        minWidth: 120,
                        groupIndex: 1
                    },
                    {
                        dataField: 'typeName',
                        caption: 'Tipo',
                        minWidth: 80
                    },
                    {
                        dataField: 'createdAt',
                        caption: 'Criado em',
                        dataType: 'date',
                        format: 'dd/MM/yyyy hh:mm',
                        minWidth: 90
                    },
                    {
                        caption: 'CONTRATO',
                        alignment: 'center',
                        columns: [
                            {
                                dataField: 'netAmount',
                                caption: 'Vlr Cliente',
                                dataType: 'number',
                                format: function (value) {
                                    return numeral(value).format('0,0.' + '0'.repeat(2));
                                },
                                width: 90
                            },
                            {
                                dataField: 'term',
                                caption: 'Prazo',
                                dataType: 'number',
                                width: 80
                            },
                            {
                                dataField: 'installment',
                                caption: 'Parcela',
                                dataType: 'number',
                                alignment: 'center',
                                format: function (value) {
                                    return numeral(value).format('0,0.' + '0'.repeat(2));
                                },
                                width: 70
                            },
                            {
                                dataField: 'interest',
                                caption: 'Juros',
                                dataType: 'number',
                                alignment: 'center',
                                customizeText: function (data) {
                                    return `${numeral(data.value).format('0,0.0' + '0'.repeat(1))}%`;
                                },
                                width: 70
                            }
                        ]
                    },
                    ...this.isMaster() == true ? [{
                        dataField: 'affiliateName',
                        caption: 'Afiliado',
                        minWidth: 150
                    }] : [],
                    {
                        dataField: 'bankStatus',
                        caption: 'Status Banco',
                        minWidth: 80,
                        visible: (this.kind !== 'EST'),
                        groupIndex: (this.kind !== 'EST') ? 2 : -1
                    },
                    {
                        dataField: 'updatedAt',
                        caption: 'Atualizado',
                        dataType: 'date',
                        format: 'dd/MM/yyyy hh:mm',
                        alignment: 'center',
                        minWidth: 100
                    },
                    {
                        dataField: 'userName',
                        caption: 'Funcionário',
                        minWidth: 120,
                        visible: false,
                    },
                    {
                        dataField: 'origin',
                        caption: 'Origem',
                        minWidth: 120,
                        customizeText: function (data) {
                            let text;
                            switch(data.value){
                                case 'fgtslp':
                                    text = 'FGTS';
                                    break;
                                default:
                                    text = 'Aplicativo';
                                    break;
                            }
                            return text;
                        },
                    }
                ];

                if (!this.hasPageFilters) {
                    this.createPageFilters([
                        // { field: 'storeId' },
                        { field: 'statusId' },
                        { field: 'clientId' },
                        { field: 'typeId' },
                        { field: 'covenantId' },
                        { field: 'bankId' },
                        { field: 'dateRange' },
                        { field: 'affiliateId' },
                        { field: 'campaignLinkId' }
                    ]);

                    // DEFAULTS FILTERS
                    // this.setPageFilter('storeId', this.$store.state.company.selectedStore, this.$store.state.company.selectedStoreName);
                    let endDate = this.$moment().format('YYYY-MM-DD');
                    let beginDate = this.$moment().format('YYYY-MM-01');
                    this.setPageFilter(
                        'dateRange', 
                        [
                            beginDate, endDate
                        ],
                        'Entre {0} e {1}'.format(this.$moment(beginDate).format('DD/MM/YYYY'), this.$moment(endDate).format('DD/MM/YYYY'))
                    );

                    let statusList = await this.$api.dataService.search('allowedStatus', { kind: this.kind });
                    if (statusList && statusList.length) {
                        let statusKeys = statusList.map(el => el.id);
                        let statusFilterLabel = 'Sit.: Todas';
                        this.setPageFilter('statusId', statusKeys.join(), statusFilterLabel);
                    }
                }else {

                    let filters = this.$store.getters.activePageFilters;
                    this.dataFilter = {
                        statusId: filters.statusId || null,
                        clientId: filters.clientId || null,
                        typeId: filters.typeId || null,
                        covenantId: filters.covenantId || null,
                        bankId: filters.bankId || null,
                        beginDate: filters.dateRange && filters.dateRange[0] ? filters.dateRange[0] : null,
                        endDate: filters.dateRange && filters.dateRange[1] ? filters.dateRange[1] : null,
                        affiliateId: filters.affiliateId || null,
                        campaignLinkId: filters.campaignLinkId || null
                    };

                }
            }
        }
    });

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Contracts.vue